export const validate = {
    phone(value) {
        return /^1(3|4|5|6|7|8|9)\d{9}$/.test(value);
    },
    mail(value) {
        return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);
    }
}